var REACT_ELEMENT_TYPE;function _jsx(type, props, key, children) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var defaultProps = type && type.defaultProps,childrenLength = arguments.length - 3;if (props || 0 === childrenLength || (props = { children: void 0 }), 1 === childrenLength) props.children = children;else if (childrenLength > 1) {for (var childArray = new Array(childrenLength), i = 0; i < childrenLength; i++) childArray[i] = arguments[i + 3];props.children = childArray;}if (props && defaultProps) for (var propName in defaultProps) void 0 === props[propName] && (props[propName] = defaultProps[propName]);else props || (props = defaultProps || {});return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: void 0 === key ? null : "" + key, ref: null, props: props, _owner: null };}import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Modal from "../../Layout/Modal";
import { Translate } from "../../I18N";
import { removeProperty } from "../actions/templateActions";
import { hideModal } from "../../Modals/actions/modalActions";

export class RemovePropertyConfirm extends Component {
  confirm() {
    this.props.hideModal('RemovePropertyModal');
    this.props.removeProperty(this.props.propertyBeingDeleted);
  }

  render() {
    return /*#__PURE__*/(
      _jsx(Modal, { isOpen: this.props.isOpen || false, type: "danger", zIndex: 99 }, void 0, /*#__PURE__*/
      _jsx(Modal.Body, {}, void 0, /*#__PURE__*/
      _jsx("h4", {}, void 0, /*#__PURE__*/
      _jsx(Translate, {}, void 0, "Confirm deletion")
      ), /*#__PURE__*/
      _jsx("p", {}, void 0, /*#__PURE__*/
      _jsx(Translate, { translationKey: "Property delete warning" }, void 0, "Deleting a template property will delete this metadata information on all documents using this template."


      )
      ), /*#__PURE__*/
      _jsx("p", {}, void 0, /*#__PURE__*/
      _jsx(Translate, {}, void 0, "Change will take effect after saving the template")
      )
      ), /*#__PURE__*/

      _jsx(Modal.Footer, {}, void 0, /*#__PURE__*/
      _jsx("button", {
        type: "button",
        className: "btn btn-default cancel-button",
        onClick: () => this.props.hideModal('RemovePropertyModal') }, void 0, /*#__PURE__*/

      _jsx(Translate, {}, void 0, "Cancel")
      ), /*#__PURE__*/
      _jsx("button", {
        type: "button",
        className: "btn btn-danger confirm-button",
        onClick: () => this.confirm() }, void 0, /*#__PURE__*/

      _jsx(Translate, {}, void 0, "Delete Property")
      )
      )
      ));

  }
}








const mapStateToProps = (state) => {
  const propertyBeingDeleted = state.modals.toJS().RemovePropertyModal;
  return {
    propertyBeingDeleted,
    isOpen: typeof propertyBeingDeleted === 'number'
  };
};

function mapDispatchToProps(dispatch) {
  return bindActionCreators({ hideModal, removeProperty }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(RemovePropertyConfirm);